type Change = { path: string; before: unknown; after: unknown };

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const diffState = (before: unknown, after: unknown, path = ""): Change[] => {
  if (Object.is(before, after)) return [];
  if (
    !isObject(before) ||
    !isObject(after) ||
    Array.isArray(before) !== Array.isArray(after)
  ) {
    return [{ path, before, after }];
  }
  const keys = new Set([...Object.keys(before), ...Object.keys(after)]);
  return [...keys].flatMap((key) =>
    diffState(before[key], after[key], path ? `${path}.${key}` : key),
  );
};

export default diffState;
export type { Change };
